import React from 'react';
import '../css/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1 classname="privacy-title">Gizlilik Politikası</h1>

      <p>
        halısahacım.com olarak kullanıcılarımızın gizliliğine önem veriyoruz. Bu gizlilik politikası, 
        topladığımız bilgileri, bu bilgileri nasıl kullandığımızı ve kullanıcılarımızın haklarını açıklamaktadır.
      </p>

      <section>
      <h3>1. Toplanan Bilgiler</h3>
      <p>
        Kayıt işlemi sırasında ad, soyad, e-posta adresi, telefon numarası gibi kişisel bilgilerinizi topluyoruz. 
        İşletmeler ayrıca konum, saha bilgileri ve fotoğraflar gibi ek bilgiler sunar.
      </p>
      </section>

      <section>
      <h3>2. Bilgilerin Kullanımı</h3>
      <ul>
        <li>Rezervasyon taleplerinin oluşturulması ve görüntülenmesi</li>
        <li>İşletmelere mesaj gönderimi ve kullanıcılarla iletişim</li>
        <li>Destek taleplerini yanıtlamak</li>
        <li>Sistem güvenliği ve kötüye kullanımın önlenmesi</li>
      </ul>
      </section>

      <section>
      <h3>3. Bilgilerin Paylaşımı</h3>
      <p>
        Kullanıcı bilgileri üçüncü şahıslarla paylaşılmaz. Ancak yasal zorunluluklar veya yargı kararı gibi 
        durumlarda yetkili mercilerle paylaşılabilir.
      </p>
      </section>

      <section>
      <h3>4. Güvenlik</h3>
      <p>
        Kişisel verileriniz, endüstri standartlarına uygun şekilde korunmaktadır. Şifreleriniz hashlenerek saklanır.
        Yetkisiz erişime karşı gerekli tüm önlemler alınmaktadır.
      </p>
      </section>

      <section>
      <h3>5. Çerezler (Cookies)</h3>
      <p>
        Site deneyiminizi geliştirmek amacıyla çerezler kullanılır. Tarayıcı ayarlarınızdan çerezleri engelleyebilirsiniz.
      </p>
      </section>

      <section>
      <h3>6. Bilgilerin Silinmesi</h3>
      <p>
        Hesabınızı silmek veya verilerinizi kaldırmak için bizimle iletişime geçebilirsiniz. Talebiniz en geç 7 iş günü içinde işleme alınır.
      </p>
      </section>

      <section>
      <h3>7. Diğer Sitelere Bağlantılar</h3>
      <p>
        Platformumuzda üçüncü taraf sitelere yönlendiren bağlantılar olabilir. Bu sitelerin gizlilik uygulamalarından halısahacım.com sorumlu değildir.
      </p>
      </section>

      <section>
      <h3>8. Politika Güncellemeleri</h3>
      <p>
        Bu gizlilik politikası zaman zaman güncellenebilir. Değişiklikler sitede yayımlandığı andan itibaren geçerli olur.
      </p>
      </section>

      <section>
      <h3>9. İletişim</h3>
      <p>
        Gizlilik politikamızla ilgili tüm soru ve talepleriniz için bizimle <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a> adresi üzerinden iletişime geçebilirsiniz.
      </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
